// hooks/useCotaUsuario.ts
import { useState, useEffect } from "react";
import { buscarEmpreendimentosPostagemService } from "../services/buscarEmpreendimentosPostagemService";
import { Empreendimento } from "../interfaces/Empreendimento";

export const useBuscarEmpreendimentos = (fetch: boolean) => {
  const [isLoading, setIsLoading] = useState(true);
  const [empreendimento, setEmpreendimento] = useState<Empreendimento[]>([]);

  useEffect(() => {
    const fetchCotaUsuario = async () => {
      if (fetch) {
        setIsLoading(true);
        try {
          const data = await buscarEmpreendimentosPostagemService();
          if (data) {
            setEmpreendimento(data);
          } else {
            console.error("Dados não encontrados para o usuário");
          }
        } catch (error) {
          console.error("Erro ao buscar emprendimentos:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchCotaUsuario();
  }, [fetch]); // Dependência de usuarioId e fetch para garantir que a chamada seja feita quando necessário

  return { isLoading, empreendimento };
};
